import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import type { ShoppingCartDTO } from '@t/api.types';
import type { CategoryType, Plan } from '@t/productOffering.types';
import { getChargesByType } from '@components/ProductOffers/modals/ShoppingCartDrawer/utils/pricingSummary.utils';
import { ChargeSection } from '@components/Checkout/layout/ChargeSection';
import { CouponSection } from '@components/Checkout/layout/CouponSection';
import { OrderTotals } from '@components/Checkout/layout/OrderTotals';
import { extractTotalByPriceType } from '@utils/cartPricing';

interface OrderSummaryProps {
  cart: ShoppingCartDTO | null;
  plansByCategory?: Record<CategoryType, Plan[]>;
}

export const OrderSummary = ({ cart, plansByCategory }: OrderSummaryProps) => {
  if (!cart) return null;

  const monthly = getChargesByType(cart, 'recurring', plansByCategory);
  const oneTime = getChargesByType(cart, 'oneTime', plansByCategory);
  const monthlyTotal = extractTotalByPriceType(cart, 'recurring');
  const oneTimeTotal = extractTotalByPriceType(cart, 'oneTime');

  return (
    <Paper variant="orderSummaryPanel" elevation={0}>
      <Box sx={{ padding: '20px 24px' }}>
        <Typography
          className="OrderSummaryTitle"
          sx={{
            fontFamily: 'Agrandir',
            fontWeight: 500,
            fontSize: '19px',
            lineHeight: '100%',
          }}
        >
          Order Summary
        </Typography>
      </Box>

      <Divider variant="orderSummary" />

      <Box sx={{ padding: '20px 24px' }}>
        <ChargeSection title="Monthly Charges" breakdown={monthly} />
      </Box>

      <Divider variant="orderSummary" />

      <Box sx={{ padding: '20px 24px' }}>
        <ChargeSection title="One-Time Charges" breakdown={oneTime} showShipping showTaxes={false} />
      </Box>

      <Divider variant="orderSummary" />

      <Box sx={{ padding: '20px 24px' }}>
        <CouponSection />
      </Box>

      <Divider variant="orderSummary" />

      <OrderTotals monthlyTotal={monthlyTotal} oneTimeTotal={oneTimeTotal} />
    </Paper>
  );
};
